(function( $ ){
    jQuery(document).ready(function() {


        function refreshCartDrawer() {
            $.ajax({
                type: 'GET',
                url: '/',
                dataType: 'html',
                success: function (cartData) {
                    let upatedCart = $(cartData).find('#CartDrawer #CartDrawerForm');
                    let cartPrice = $(cartData).find('#CartDrawer .cart_drawer_footer .cart_total_price');
                    let cartCount = $(cartData).find('#CartDrawer .cart__items').data('count');

                    $('#CartDrawer').html(upatedCart);

                    $('#CartDrawer .cart_drawer_footer .cart_total_price').html(cartPrice);
                    $('#CartBubble .cart-link__bubble-num').text(cartCount);
                },
                error: function(error) {
                    console.log(error)
                    console.log(error.responseJSON.description);
                }
            });
        }


        $(document).on('click', '.cart_quantity_price_wrp .js-qty__adjust', function(e) {

            let quantityField = $(this).parents('.js-qty__wrapper').find('.js-qty__num');
            var currentValue = parseInt(quantityField.val());
            let itemKey = $(this).parents('.cart_item').data('key');
            let cartUrl = "/cart/change.js";

            if($(this).hasClass('btn_minus')) {

                if(currentValue > 0) {
                    quantityField.val(currentValue - 1);
                } else {
                    return;
                }

            } else if ($(this).hasClass('btn_plus')) {

                quantityField.val(currentValue + 1);
            }

            let updatedValue = $(this).parents('.js-qty__wrapper').find('.js-qty__num').val();

            $('.cart_items_wrp').addClass('btn--loading');

            $.ajax({
                url: cartUrl,
                type: "POST",
                dataType: "json",
                data: {
                    id: itemKey,
                    quantity: updatedValue
                },
                success: function(response) {
                    refreshCartDrawer();
                    $('.cart_items_wrp').removeClass('btn--loading');
                },
                error: function(error) {
                    $('.drawer__cart-empty .drawer__scrollable').text(error.responseJSON.description);
                }
            });
        });


        // Variation Option Dropdown

        $(document).on('click', '.size_variation_title', function(e) {
            e.stopPropagation();
            $('.variation_dropdown').slideToggle();
            $(this).toggleClass('dropdown_active');
        });

        $(document).click(function(e) {
            if (!$(e.target).closest('.variaion_option_title').length &&
                !$(e.target).closest('.variation_dropdown').length) {

                $('.variation_dropdown').slideUp();
                $('.size_variation_title').removeClass('dropdown_active');
            }
        });

        $(document).on('click', '.dropdown_variant_option', function(e) {
            $('.variation_dropdown').slideUp();
            $('.size_variation_title').removeClass('dropdown_active');
        });


        $(document).on('click', '.product-single__form .js-qty__wrapper .js-qty__adjust--plus', function(e) {

            let currentQuantity = $(this).parents('.js-qty__wrapper').find('.js-qty__num');
            var currentValue = parseInt(currentQuantity.val());

            currentQuantity.val(currentValue + 1);
        });

        $(document).on('click', '.product-single__form .js-qty__wrapper .js-qty__adjust--minus', function(e) {

            let currentQuantity = $(this).parents('.js-qty__wrapper').find('.js-qty__num');
            var currentValue = parseInt(currentQuantity.val());

            if(currentValue > 1) {
                currentQuantity.val(currentValue - 1);
            }
        });


        $('.length_selection_option .variant_button:first-child').addClass('selected_legnth');


        // Cross Sell products

        $('.length_selection_option .vari_length_option').click(function(e){

            e.preventDefault();

            $(this).parents('.cross_product_item').addClass('selected_variation');

            let selectedVariantId = $(this).data('pro-link');
            let selectedProID = $(this).data('variant-id');

            $(this).parents('form').attr('id', selectedProID);

            let selectedProduct = $(this).data('product-url');

            let url = selectedVariantId + '.js';

            $(this).parent('.variant_button').siblings().removeClass('selected_legnth');
            $(this).parent('.variant_button').addClass('selected_legnth');

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json',
                success: function(productData) {

                    var proName = productData.title;

                    console.log(productData.variants);

                    $('.selected_variation .product_heading .sub_heading').text(proName);
                    $('.selected_variation .product_image img').attr('src', productData.featured_image);

                    let lengthVariation = $('.selected_variation .vari_length_selection');

                    $('.selected_variation .vari_length_selection option').remove();

                    $.each(productData.variants, function(index, item) {
                        lengthVariation.append($('<option>', {
                            value: item.id,
                            text: item.title
                        }));
                    });
                },
                error: function(error) {
                    console.error('Error fetching product data:', error);
                }
            });
        });


        $('.color_vari_options .color_item').click(function(){

            $(this).parents('.cross_product_item').siblings().removeClass('color_vari_selected');
            $(this).parents('.cross_product_item').addClass('color_vari_selected');

            let selectedColor = $(this).data('pro-url');
            let url = selectedColor + '.js';

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json',
                success: function(productData) {

                    var proName = productData.title;

                    $('.color_vari_selected .product_heading .sub_heading').text(proName);
                    $('.color_vari_selected .product_image img').attr('src', productData.featured_image);

                    if($('.color_vari_selected .vari_length_selection').length) {

                    } else {

                        $('.color_vari_selected form').prepend(
                            '<select name="id" id="" class="vari_length_selection"><option value="">Select Size AU</option></select>'
                        );
                    }

                    $('.color_vari_selected .vari_length_selection option').remove();

                    let lengthVariation = $('.color_vari_selected .vari_length_selection');

                    $.each(productData.variants, function(index, item) {
                        lengthVariation.append($('<option>', {
                            value: item.id,
                            text: item.title
                        }));
                    });

                    if (productData.variants.length == 1) {
                        $('.color_vari_selected .vari_length_selection').hide();
                    } else {
                        $('.color_vari_selected .vari_length_selection').show();
                    }
                },
                error: function(error) {
                    console.error('Error fetching product data:', error);
                }
            });
        });


        $(".variation_dropdown .dropdown_variant_option:first-child input").prop("checked", false);


        $(document).on('click', '.single_tocart_btn', function(e) {

            var noSelection = true;

            $('.variation_dropdown .dropdown_variant_option').each(function() {

                var selected = $(this).find('input[type="radio"]:checked').length > 0;

                if (selected) {
                    noSelection = false;
                }
            });

            if (!$(this).parents('.product-single__form').find(".variation_dropdown").length > 0) {
                noSelection = false;
            }

            // Validation for Gift Card Product
            if ($(".one-mile-the-label-gift-card").length > 0) {
                noSelection = false;
            }

            if (noSelection) {

                $('.variant_not_selected').text('Please select size first ');
                $('.variant_not_selected').show();

                setTimeout(function() {
                    $('.variant_not_selected').hide();
                }, 3000);

                e.preventDefault();
                return;

            } else {

                $('.variant_not_selected').hide();

                let proId = $('.single_tocart_btn').data('productid');

                let proQuantity = $(this)
                    .parents('.product-single__form')
                    .find('.product__quantity .js-qty__num')
                    .val();

                if (!$(".variation_dropdown").length > 0) {

                    productVariantId = $(this)
                        .parents('.product-single__form')
                        .find('.single_tocart_btn')
                        .attr('data-productid');

                    console.log('single product id: ' + productVariantId);
                }

                $(this).addClass('btn--loading');

                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: proQuantity,
                        id: productVariantId
                    },
                    dataType: 'json',
                    success: function(response) {

                        refreshCartDrawer();

                        $('.single_tocart_btn').removeClass('btn--loading');
                        $('.js-drawer-open-cart .cart-link').trigger("click");
                    },
                    error: function(error) {

                        console.log(error);

                        $('.variant_not_selected').text(error.responseJSON.description);
                        $('.variant_not_selected').show();

                        $('.single_tocart_btn').removeClass('btn--loading');
                    }
                });
            }

            e.preventDefault();
        });


        $('body.coming-soon.template-collection .modal__inner .single_tocart_btn span').text('Coming Soon');


        $(".product_img_gallery .product_img img").each(function () {

            let imageSrc = $(this)
                .parents('.product_img_gallery')
                .find('.product_second_image img')
                .attr('src');

            var dataSrc = $(this).data("src");

            if (dataSrc === imageSrc) {
                $(this).parent('.product_img').addClass("second_repeated_image");
            }
        });


        $(document).on('click', '.js-drawer-close', function(e) {

            $('.cart_drawer_wrp #CartDrawer').removeClass('drawer--is-open');

            $('html').removeClass('js-drawer-open');
            $('html').removeClass('lock-scroll');
            $('html').addClass('js-drawer-closing');

            $('.js-drawer-open-cart').attr("aria-expanded", "false");

            $("#CartDrawer").removeAttr("tabindex");

            $('.cart_drawer_wrp #CartDrawer').addClass('is-transitioning');

            setTimeout(function() {
                $('html').removeClass('js-drawer-closing');
            }, 200);

            e.preventDefault();

            return false;
        });


        $('.js-drawer-open-cart').click(function(e){

            $('.cart_drawer_wrp #CartDrawer').addClass('drawer--is-open');

            $('html').addClass('js-drawer-open');
            $('html').addClass('lock-scroll');
            $('html').addClass('js-drawer-closing');

            $('.js-drawer-open-cart').attr("aria-expanded", "true");

            $("#CartDrawer").attr("tabindex", '-1');

            $('.cart_drawer_wrp #CartDrawer').removeClass('is-transitioning');

            e.preventDefault();

            return false;
        });


        $(".vari_length_selection").change(function() {

            var selectedValue = $(this).val();

            $(this).parent('form').attr('id', selectedValue);

            $(this).parent('form').find('.cross_atc_btn').removeClass('select_size_error');
        });


        $(document).on('click', '.js-modal-close', function(e) {

            $('.product-single__form .variation_dropdown .dropdown_variant_option input').prop("checked", false);

            $('.product-single__form .size_variation_title .size_label').text('Select Size');
        });


        $(document).on('click', '.modal__inner .single_tocart_btn', function(e) {

            setTimeout(function() {

                $('.product-single__form .variation_dropdown .dropdown_variant_option input').prop("checked", false);

                $('.product-single__form .size_variation_title .size_label').text('Select Size');

            }, 1000);
        });


        // Gift Card Product

        let giftCardFirstVal = $(".one-mile-the-label-gift-card .product-single__variants")
            .val($(".product-single__variants option:first").val());

        $('.one-mile-the-label-gift-card .product-single__variants')
            .prepend('<option value="" disabled selected>Select Gift Card</option>');

        $('.single_tocart_btn').data('productid', giftCardFirstVal);

        $(".one-mile-the-label-gift-card .product-single__variants").change(function () {

            var selectedValue = $(this).val();

            productVariantId = selectedValue;
        });


        $('.cross_product_item .btn-add-to-cart').click(function(e) {

            e.preventDefault();

            let selectedProductId = $(this).parents('.cross_product_item').data('product-id');

            let $lengthValue = $(this).parents('.vari_option_wrp').find('form');

            if($lengthValue.find('.size_variant_dropdown').length > 0) {

                if ($lengthValue.attr('data-value')) {

                    $(this).prop("disabled", false);

                    $(this).parent('.cross_atc_btn').removeClass('select_size_error');

                } else {

                    $(this).parent('.cross_atc_btn').addClass('select_size_error');

                    setTimeout(function() {
                        $(this).parent('.cross_atc_btn').removeClass('select_size_error');
                    }, 3000);

                    e.preventDefault();

                    return;
                }
            }

            $(this).parent('.cross_atc_btn').removeClass('no_value_selected');

            $(this).addClass('btn--loading');

            var productId = $(this).parents('form').attr('id');

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    quantity: 1,
                    id: productId
                },
                dataType: 'json',
                success: function(response) {

                    $('.cross_product_item .btn-add-to-cart').removeClass('btn--loading');

                    refreshCartDrawer();

                    $('.js-drawer-open-cart .cart-link').trigger("click");

                    $('.single_tocart_btn').removeClass('btn--loading');
                },
                error: function(error) {

                    $('.cross_product_item .btn-add-to-cart').removeClass('btn--loading');

                    let selectedPro = $('[data-product-id="' + selectedProductId + '"]');

                    $(selectedPro)
                        .find('.cart_error_text')
                        .text(error.responseJSON.description)
                        .show();

                    setTimeout(function() {

                        $(selectedPro).find('.cart_error_text').hide();

                    }, 2000);
                }
            });
        });


        $(".vari_length_selection").each(function(index) {

            if ($(this).length > 0) {

                var selectValue = $(this).val();

                $(this).parents('form').attr('id', selectValue);
            }
        });


        $(".pant_length_variants").each(function() {

            if ($(this).find(".length_selection_option .variant_button").length === 0) {

                $(this).addClass("empty_variant");
            }
        });


        function checkWidth() {

            var windowWidth = $(window).width();

            if (windowWidth < 767) {

                $('.page-content--product .product_img_gallery')
                    .addClass('owl-carousel owl-theme');

                $('.product_img_gallery').owlCarousel({
                    loop: true,
                    autoplay: true,
                    autoplayTimeout: 7000,
                    slideTransition: 'linear',
                    autoplayHoverPause: true,
                    margin: 0,
                    nav: false,
                    items: 1,
                    stagePadding: 5
                });

            } else {

                $('#elementToModify').removeClass('owl-carousel owl-theme');
            }
        }


        // Initial check on document ready
        checkWidth();


        // Attach a resize event listener to the window
        $(window).resize(function() {
            checkWidth();
        });


        $('.left_col_wrp .collapsible-trigger').click(function() {

            let accordionContent = $(this).next('.collapsible-content').height();

            if (accordionContent == 0) {

                $('.pro_single_left_col .product-single__meta')
                    .addClass('overlay_zindex');

            } else {

                $('.pro_single_left_col .product-single__meta')
                    .removeClass('overlay_zindex');
            }

            $('.collapsible-content')
                .not($(this).next('.collapsible-content'))
                .removeClass('active_dropdown');

            $(this)
                .next('.collapsible-content')
                .toggleClass('active_dropdown');
        });


        /*
         * Main PDP size selector.
         *
         * The visible One Mile size selector is custom, so we also update
         * Shopify's real select[name="id"] whenever a size is chosen.
         *
         * This allows Klaviyo Back in Stock to identify the exact
         * selected sold-out Shopify variant.
         */

        var productVariantId = '';

        $(document).on(
            'change',
            '.variation_dropdown .dropdown_variant_option .variant_option_input',
            function() {

                var newValue = $(this).val();

                $('.size_variation_title .size_label').text(newValue);

                productVariantId = $(this).data('variantid');

                var $productForm = $(this).parents('form');

                $productForm
                    .find('.single_tocart_btn')
                    .attr('data-productid', productVariantId);


                let sizeVariantValue = $(this)
                    .parent('.dropdown_variant_option')
                    .find('.label_text')
                    .text();

                $('.size_variation_title .size_label').text(sizeVariantValue);


                /*
                 * Keep Shopify's underlying variant selector synced
                 * with the custom visible size selector.
                 */
                var $variantSelect = $productForm.find('select[name="id"]');

                $variantSelect
                    .val(String(productVariantId))
                    .trigger('change');


                let checkStock = $(this)
                    .parent()
                    .find('.variant__button-label');


                if (checkStock.hasClass('disabled')) {

                    console.log('no stock!!');

                    $productForm
                        .find('.single_tocart_btn span')
                        .text('Out of Stock');

                    $productForm
                        .find('.single_tocart_btn')
                        .prop('disabled', true);

                } else {

                    $productForm
                        .find('.single_tocart_btn span')
                        .text('Add to Cart');

                    $productForm
                        .find('.single_tocart_btn')
                        .prop('disabled', false);
                }
            }
        );


        $('.length_variation_title').click(function(){

            $(this)
                .next('.length_selection_option')
                .slideToggle();

            $(this).toggleClass('dropdown_active');
        });


        if (!$('.complete_look_block_wrp .cross_product_item').length) {

            $('.complete_look_block_wrp').addClass('no_look_block');
        }


        $(document).on('click', '.left_col_wrp .collapsible-trigger-btn', function(e) {

            var content = $(this).next(".collapsible-content");

            var icon = $(this).find(".collapsible-trigger__icon");

            $(".left_col_wrp .collapsible-content")
                .not(content)
                .slideUp();

            $(".left_col_wrp .collapsible-content")
                .not(content)
                .removeClass('zindex_change');

            $('.left_col_wrp .collapsible-trigger-btn')
                .not(this)
                .find(".collapsible-trigger__icon")
                .removeClass("open");

            content.slideToggle();

            $(content).toggleClass('zindex_change');

            icon.toggleClass("open");

            var state = $(this).data("state");

            if (state === "closed") {

                $(this).data("state", "open");

            } else {

                $(this).data("state", "closed");
            }

            if ($(".zindex_change").length > 0) {

                $('.complete_look_block_wrp').addClass('active_acc');

            } else {

                setTimeout(function() {

                    $('.complete_look_block_wrp').removeClass('active_acc');

                }, 500);
            }
        });


        $('.collapsible-trigger').click(function() {

            console.log('faq open');

            $('.collapsible-trigger')
                .not(this)
                .next('.collapsible-content')
                .removeClass('is-open');

            $('.collapsible-trigger')
                .not(this)
                .removeClass('is-open');
        });


        $('.cart-link__bubble').addClass('cart-link__bubble--visible');


        // Product Slider Section

        $('.products_slider').owlCarousel({
            loop: false,
            autoplay: false,
            margin: 0,
            nav: true,
            navText: [
                "<img src='https://cdn.shopify.com/s/files/1/0334/8171/9945/files/arrow-left-icon.svg?v=1695188568'>",
                "<img src='https://cdn.shopify.com/s/files/1/0334/8171/9945/files/arrow-right-icon.svg?v=1695188568'>"
            ],
            responsive: {
                0: {
                    items: 2.1
                },
                767: {
                    items: 3
                },
                1024: {
                    items: 4
                }
            }
        });


        document
            .querySelector('.discount_text .discount_popup')
            .addEventListener('click', function (){

                window._klOnsite = window._klOnsite || [];

                window._klOnsite.push([
                    'openForm',
                    'SMhDck'
                ]);
            });


        var numberInput = $(".product__quantity .js-qty__num");


        $(".qty__adjust--plus").click(function() {

            var currentValue = parseInt(numberInput.val());

            numberInput.val(currentValue + 1);
        });


        $(".qty__adjust--minus").click(function() {

            var currentValue = parseInt(numberInput.val());

            if (currentValue > 0) {
                numberInput.val(currentValue - 1);
            }
        });


        if ($(".product_video").length > 0) {

            $('.product_img_gallery').addClass('has_video_medio');
        }


        var windowWidth = $(window).width();

        if (windowWidth < 767) {

        }


        $('.complete_look_block_wrp .ctl_variatant_title').click(function(){

            $(this)
                .next('.size_variant_dropdown')
                .slideToggle();

            $(this).toggleClass('dropdown_active');
        });


        $('.ctl_variant_option_item').each(function(){

            $(this).click(function(){

                $(this).addClass('selected_variatnt');

                $(this).siblings().removeClass('selected_variatnt');

                let selectedSize = $(this)
                    .find('.ctl_variant_value')
                    .text();

                let selectedValue = $(this).data('value');

                $(this)
                    .parents('.vari_option_wrp')
                    .find('.cross_atc_btn')
                    .removeClass('select_size_error');

                $(this)
                    .parents('form')
                    .attr('id', selectedValue);

                $(this)
                    .parents('form')
                    .attr('data-value', selectedValue);

                $(this)
                    .parents('form')
                    .find('.ctl_variatant_title .variantvalue')
                    .text(selectedSize);


                if($(this).hasClass('disable')) {

                    $(this)
                        .parents('.vari_option_wrp')
                        .find('.btn-add-to-cart')
                        .text('Out of Stock');

                    $(this)
                        .parents('.vari_option_wrp')
                        .find('.btn-add-to-cart')
                        .prop("disabled", true);

                    $(this)
                        .parents('.vari_option_wrp')
                        .find('.ctl_waitlist_btn')
                        .show();

                    $(this)
                        .parents('.vari_option_wrp')
                        .find('.ctl_waitlist_btn a')
                        .attr('data-variant-id', selectedValue);

                } else {

                    $(this)
                        .parents('.vari_option_wrp')
                        .find('.btn-add-to-cart')
                        .text('Add to Cart');

                    $(this)
                        .parents('.vari_option_wrp')
                        .find('.btn-add-to-cart')
                        .prop("disabled", false);

                    $(this)
                        .parents('.vari_option_wrp')
                        .find('.ctl_waitlist_btn')
                        .hide();
                }
            });
        });


        $(document).click(function(e) {

            if (!$(e.target).closest('.ctl_variatant_title').length &&
                !$(e.target).closest('.size_variant_dropdown').length) {

                $('.size_variant_dropdown').slideUp();

                $('.ctl_variatant_title').removeClass('dropdown_active');
            }
        });


        $(document).on('click', '.ctl_variant_option_item', function(e) {

            $('.size_variant_dropdown').slideUp();

            $('.ctl_variatant_title').removeClass('dropdown_active');
        });


        $('.pro_single_left_col .cross_product_item').each(function(){

            if($(this).hasClass('Ring')) {

            } else {

                $(this).find('.ctl_variant_option_item').each(function(){

                    if($(this).find('.ctl_variant_value').text().trim() == 4) {

                        let size4 = $('.comparison_sizes_listing .au_size_4').text();

                        $(this).find('.inner_label_text').text(size4);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 6) {

                        let size6 = $('.comparison_sizes_listing .au_size_6').text();

                        $(this).find('.inner_label_text').text(size6);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 8) {

                        let size8 = $('.comparison_sizes_listing .au_size_8').text();

                        $(this).find('.inner_label_text').text(size8);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 10) {

                        let size10 = $('.comparison_sizes_listing .au_size_10').text();

                        $(this).find('.inner_label_text').text(size10);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 12) {

                        let size12 = $('.comparison_sizes_listing .au_size_12').text();

                        $(this).find('.inner_label_text').text(size12);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 14) {

                        let size14 = $('.comparison_sizes_listing .au_size_14').text();

                        $(this).find('.inner_label_text').text(size14);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 16) {

                        let size16 = $('.comparison_sizes_listing .au_size_16').text();

                        $(this).find('.inner_label_text').text(size16);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 18) {

                        let size18 = $('.comparison_sizes_listing .au_size_18').text();

                        $(this).find('.inner_label_text').text(size18);
                    }

                    if($(this).find('.ctl_variant_value').text().trim() == 20) {

                        let size20 = $('.comparison_sizes_listing .au_size_20').text();

                        $(this).find('.inner_label_text').text(size20);
                    }
                });
            }
        });


    }); // end of ready func.


    window.onload = function(){

        setTimeout(function() {

            $('.template-product .products_slider').owlCarousel({
                loop: false,
                autoplay: false,
                margin: 0,
                nav: true,
                navText: [
                    "<img src='https://cdn.shopify.com/s/files/1/0334/8171/9945/files/arrow-left-icon.svg?v=1695188568'>",
                    "<img src='https://cdn.shopify.com/s/files/1/0334/8171/9945/files/arrow-right-icon.svg?v=1695188568'>"
                ],
                responsive: {
                    0: {
                        items: 2.1
                    },
                    767: {
                        items: 3
                    },
                    1024: {
                        items: 4
                    }
                }
            });

        }, 1500);
    };

})( jQuery );